<template>
	<div class="page">
    <div class="top">
      <NavBar
	      style="background-color: #ed143f; color: white"
	      title="购物车"
	      left-arrow
	      @click-left="onClickLeft"
	      :border="false"
      >
      </NavBar>
	    <NoticeBar color="#fff" background="#ed143f">
			  共{{ this.list.length }}件宝贝
			</NoticeBar>
    </div>
		<div class="list">
			<Card class="good-card" v-for="(item, index) in list" :key="index">
				<template #title>
					<p class="good-title">{{ item.goodsInfo.goodsName }}</p>
				</template>
				<template #desc>
					<p><span>监控价格：</span><span>{{ item.goodsInfo.price }} /天</span></p>
				</template>
				<template #tags>
					<p style="display: flex; justify-content: space-between"><span>监控天数：</span><Stepper button-size="20px" v-model="item.days" /></p>
				</template>
				<template #thumb>
					<div style="display: flex; justify-content: space-between; align-items: center; height: 100%">
						<Checkbox v-model="item.checked" @change="onBoxChange(item)"></Checkbox>
						<VanImage width="100px" height="100px" :src="item.goodsImages && item.goodsImages[0].imageUrl"></VanImage>
					</div>
				</template>
			</Card>
		</div>
		<SubmitBar v-show="!isEdit" :price="price" :button-text="buttonText" @submit="onSubmit" :loading="loading">
		  <Checkbox v-model="checkedAll" @change="onBoxAllChange">全选</Checkbox>
		</SubmitBar>
		<SubmitBar v-show="isEdit" button-text="删除" @submit="onDelete">
		  <Checkbox v-model="checkedAll2" @change="onBoxAllChange">全选</Checkbox>
		</SubmitBar>
  </div>
</template>

<script>
	import { NavBar, Cell, Image as VanImage, CellGroup, Icon, NoticeBar, SubmitBar, Checkbox, Card, Stepper } from 'vant';

  export default {
    components: {NavBar, Cell, VanImage, CellGroup, Icon, NoticeBar, SubmitBar, Checkbox, Card, Stepper},
	  data() {
      return {
        checked: false,
        checkedAll: false,
		checkedAll2: false,
		loading: null,
        days: 1,
	      isEdit: false,
	      list: [],
	      checkedList: []
      }
	  },
	  computed: {
      buttonText() {
        return `结算(${this.checkedList.length})`
      },
      rightText() {
        return this.isEdit ? '完成': '管理'
      },
      price() {
        const yuan = this.checkedList.reduce((acc, v) => {
          acc = acc + v.goodsInfo.price * v.days;
          return acc
        }, 0)
	      return yuan * 100
      }
	  },
    created() {
      this.list = this.$store.state.shopCar
	  },
	  methods: {
      onClickRight() {
        this.isEdit = !this.isEdit;
      },
      onClickLeft() {
        this.$router.back();
      },
      async onSubmit() {
        this.loading = true;
        const param = this.checkedList.map(v => {
          return {
            goodsInfoId: v.goodsInfo.id,
            goodsNum: v.days,
            remark: ''
          }
        })
        await this.$store.dispatch('handleOrder', param);
        this.loading = false;
      },
      onBoxChange(target) {
        const checked = target.checked;
        if(checked) {
          this.checkedList.push(target);
        } else {
          this.checkedList = this.checkedList.filter(v => v.goodsInfo.id !== target.goodsInfo.id)
        }
      },
      onBoxAllChange(val) {
				this.list = this.list.map(v => {
				  return {
					  ...v,
					  checked: val
				  }
				})
      },
      onDelete() {

      }
	  }
  }
</script>

<style lang="less" scoped>
	.page {
		height: 100%;
		background-color: #f5f5f5;
	}

	.good-card {
		margin: 10px;
		border-radius: 5px;

		/deep/.van-card__thumb {
			width: 120px;
		}
	}

	.good-title {
		font-size: 14px;
	}

	.top {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 2;

		/deep/.van-nav-bar__title {
			color: #fff;
		}
		/deep/.van-nav-bar__text,
		/deep/.van-icon{
			color: #fff;
		}
	}

	.list {
		height: 100%;
		box-sizing: border-box;
		padding-top: 86px;
		padding-bottom: 50px;
		overflow-y: auto;
	}

</style>
